// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reserved for component-specific styles. Global tokens live in index.css */
.App {
  min-height: 100vh;
  background: var(--bond-bg);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;EACE,iBAAiB;EACjB,0BAA0B;AAC5B","sourcesContent":["/* Reserved for component-specific styles. Global tokens live in index.css */\n.App {\n  min-height: 100vh;\n  background: var(--bond-bg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
